<form [formGroup]="formGroup" class="mas">
  @if (pageTitle) {
    <div class="mas-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="mas-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }

  @if (grades.length) {
    <div class="mas-guide">
      <div class="mas-guide-title">{{ "MAS_GuideTitle" | translate }}</div>
      <ul class="mas-guide-list">
        @for (grade of grades; track grade.label) {
          <li>
            <span class="mas-guide-grade">{{ grade.label }}</span>
            <span>{{ grade.description }}</span>
          </li>
        }
      </ul>
    </div>
  }

  @if (rows.length) {
    <div class="mas-row mas-columns">
      <div>{{ getQuestionTitle(rowsElement?.title) }}</div>
      <div>{{ getQuestionTitle(gradeElement?.title) }}</div>
      <div></div>
    </div>
  } @else {
    <div class="mas-empty">{{ "No muscles recorded" | translate }}</div>
  }

  @for (row of rows.controls; track row; let i = $index) {
    <div class="mas-row">
      <input
        type="text"
        class="mas-input"
        [placeholder]="isEditable ? ('MAS_MusclePlaceholder' | translate) : ''"
        [formControl]="row.controls.muscle"
        (keydown.enter)="$event.preventDefault()"
      />
      <div class="mas-grades">
        @for (grade of grades; track grade.label) {
          <label
            class="mas-grade"
            nz-tooltip
            [nzTooltipTitle]="grade.description"
          >
            <!-- [name] groups the row for Angular, [attr.name] for the browser. -->
            <input
              type="radio"
              [name]="'mas-grade-' + rowIds[i]"
              [attr.name]="'mas-grade-' + rowIds[i]"
              [value]="grade.label"
              [formControl]="row.controls.grade"
              (click)="onGradeClick(row, grade.label)"
            />
            <span>{{ grade.label }}</span>
          </label>
        }
      </div>
      <div class="mas-actions">
        @if (isEditable) {
          <!-- The care team form's remove button. -->
          <button
            type="button"
            class="mas-remove"
            [title]="'Remove' | translate"
            (click)="removeRow(i)"
          >
            <i class="fa-regular fa-trash-can"></i>
          </button>
        }
      </div>
      @if (getRowError(row); as error) {
        <div class="mas-error">{{ error | translate }}</div>
      }
    </div>
  }

  @if (isEditable) {
    <button
      type="button"
      nz-button
      nzType="dashed"
      class="mas-add"
      (click)="addRow()"
    >
      <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
      <span>{{ "Add muscle" | translate }}</span>
    </button>
  }
</form>
